module.exports = __webpack_public_path__ + "media/images/gallery/constellations/dn_layer_off-b9428461809754ff4639013694dfd677.png";